import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyABuGbivPhsOuRqwH3GamcIQ7FTu60t9Y0",
  authDomain: "hayaachessapp.firebaseapp.com",
  projectId: "hayaachessapp",
  storageBucket: "hayaachessapp.firebasestorage.app",
  messagingSenderId: "1050684166974",
  appId: "1:1050684166974:web:6ab97ea514dfb7a7b2d26f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
